import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CardMenu, CardMenuHeader } from '../../cardMenu/components/CardMenu';
import ChangePlaylistThumbnail from './ChangePlaylistThumbnail';
import { UploadPlaylistThumbnailButton } from './UploadPlaylistThumbnailButton';
import { useFullPlaylist } from '../savedItemsQueries';
import PanelSection from '../../../components/Modals/FullScreenModal/PanelSection';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { MenuRow } from '../../cardMenu/components/MobileCardMenu';
import UsageTracker from '../../../utils/UsageTracker';
import { HR } from 'foundations-components/transitional/components/HR';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import RouterSideNav from 'ui-addon-react-router-dom/RouterSideNav';
import { SideNavItem } from 'foundations-components/transitional/components/SideNav';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { RightIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MobileMenuChangePlaylistThumbnailOption = ({
  playlistId,
  onItemClick
}) => {
  return /*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
    onItemClick: onItemClick,
    playlistId: playlistId,
    renderList: content => /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PanelSection, {
        showBorders: false,
        title: /*#__PURE__*/_jsx(TFlex, {
          children: /*#__PURE__*/_jsx(Box, {
            grow: 1,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.cardMenu.playlistItems"
            })
          })
        })
      }), content]
    }),
    renderRow: (content, key) => /*#__PURE__*/_jsx(MenuRow, {
      children: content
    }, key)
  });
};
const useIsLoadingPlaylistItems = (playlistId, isOpen) => {
  const {
    playlistLoading
  } = useFullPlaylist(playlistId, !isOpen);
  return playlistLoading;
};
export const CardMenuChangePlaylistThumbnailOption = ({
  playlistId,
  onItemClick,
  onOpenChange,
  render = (handleOpen, isLoading) => /*#__PURE__*/_jsx(SideNavItem, {
    iconRight: isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      insetInlineEnd: "10px",
      position: "absolute",
      size: "extra-small"
    }) : /*#__PURE__*/_jsx(IconHolder, {
      color: "icon-interactive-default",
      icon: RightIcon,
      marginInlineEnd: "-100",
      size: "100"
    }),
    onClick: handleOpen,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.cardMenu.changeThumbnail"
    })
  })
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const handleOnOpenChange = newOpenState => {
    setIsOpen(newOpenState);
    if (onOpenChange) onOpenChange(newOpenState);
  };
  const handleOnItemClick = item => {
    if (onItemClick) onItemClick(item);
    handleOnOpenChange(false);
    UsageTracker.track('playlistInteraction', {
      action: 'choose-thumbnail'
    });
  };
  const handleOnImageUpload = () => {
    handleOnOpenChange(false);
    UsageTracker.track('playlistInteraction', {
      action: 'upload-thumbnail'
    });
  };
  const handleOpen = () => handleOnOpenChange(true);
  const isLoading = useIsLoadingPlaylistItems(playlistId, isOpen);
  return /*#__PURE__*/_jsx(CardMenu, {
    content: {
      header: /*#__PURE__*/_jsx(CardMenuHeader, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.cardMenu.playlistItems"
        })
      }),
      body: /*#__PURE__*/_jsx(ChangePlaylistThumbnail, {
        onItemClick: handleOnItemClick,
        playlistId: playlistId
      }),
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "flush"
        }), /*#__PURE__*/_jsx(RouterSideNav, {
          paddingInlineStart: "300",
          children: /*#__PURE__*/_jsx(SideNavItem, {
            linkComponent: "div",
            role: "navigation-item",
            title: /*#__PURE__*/_jsx(UploadPlaylistThumbnailButton, {
              block: true,
              onImageUpload: handleOnImageUpload,
              playlistId: playlistId,
              use: "link"
            })
          })
        })]
      })
    },
    onOpenChange: e => handleOnOpenChange(e.target.value),
    open: isOpen && !isLoading,
    placement: "right bottom",
    children: render(handleOpen, isLoading)
  });
};